import api from '../lib/api'

export const listCustomStatuses = (tenantId, entityType) =>
  api.get(`/manager/${tenantId}/custom-statuses`, { params: { entity_type: entityType } }).then(r => r.data)

export const createCustomStatus = (tenantId, body) =>
  api.post(`/manager/${tenantId}/custom-statuses`, body).then(r => r.data)

export const patchCustomStatus = (tenantId, statusId, body) =>
  api.patch(`/manager/${tenantId}/custom-statuses/${statusId}`, body).then(r => r.data)

export const deleteCustomStatus = (tenantId, statusId) =>
  api.delete(`/manager/${tenantId}/custom-statuses/${statusId}`).then(r => r.data)

const customStatusesByKey = new Map()
const customStatusesInflight = new Map()

function cacheKey(tenantId, entityType) {
  return `${tenantId}::${entityType}`
}

/** Cached default+custom status list per tenant+entity_type — one network fetch until invalidate. */
export function getCachedCustomStatuses(tenantId, entityType) {
  if (!tenantId) return Promise.resolve([])
  const key = cacheKey(tenantId, entityType)
  const cached = customStatusesByKey.get(key)
  if (cached) return Promise.resolve(cached)
  if (customStatusesInflight.has(key)) return customStatusesInflight.get(key)

  const promise = listCustomStatuses(tenantId, entityType)
    .then(items => {
      customStatusesByKey.set(key, items)
      customStatusesInflight.delete(key)
      return items
    })
    .catch(err => {
      customStatusesInflight.delete(key)
      throw err
    })
  customStatusesInflight.set(key, promise)
  return promise
}

export function invalidateCustomStatusesCache(tenantId, entityType) {
  if (tenantId && entityType) {
    customStatusesByKey.delete(cacheKey(tenantId, entityType))
    customStatusesInflight.delete(cacheKey(tenantId, entityType))
    return
  }
  customStatusesByKey.clear()
  customStatusesInflight.clear()
}
